import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export var FlowGenerateFileMode;
(function (FlowGenerateFileMode) {
    FlowGenerateFileMode["DocumentTemplate"] = "DocumentTemplate";
    FlowGenerateFileMode["Markdown"] = "Markdown";
    FlowGenerateFileMode["Base64ToFile"] = "Base64ToFile";
    FlowGenerateFileMode["Html"] = "Html";
})(FlowGenerateFileMode || (FlowGenerateFileMode = {}));
export const FlowGenerateFileBlockConfigSchema = z.discriminatedUnion('mode', [
    z.object({
        mode: z.literal(FlowGenerateFileMode.DocumentTemplate),
        documentTemplateId: z.uuid(),
        valuesByDocumentTemplateKey: z.record(z.string(), z.string().optional()),
    }),
    z.object({
        mode: z.literal(FlowGenerateFileMode.Markdown),
        markdown: z.string(),
    }),
    z.object({
        mode: z.literal(FlowGenerateFileMode.Base64ToFile),
        base64Payload: z.string(),
    }),
    z.object({
        mode: z.literal(FlowGenerateFileMode.Html),
        html: z.string(),
    }),
]);
export const FlowGenerateFileBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GenerateFile),
    config: FlowGenerateFileBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.FileReference),
});
//# sourceMappingURL=config.js.map